import { type PlayerComponentInitOptions, type CreatePlayerComponent } from '@source-digital/experience-player-core'
import PlyrComponent from './components/PlyrComponent.vue'
import { ComponentPublicInstance, createApp, h } from 'vue'
import { toValue } from '@vueuse/core'
import { PlyrMediaControls } from './media-controls'

export const createPlayerComponent: CreatePlayerComponent = () => {
  let instance: { $refs: { plyrTemplate: ComponentPublicInstance<typeof PlyrComponent> } } | null = null

  return {
    async init (options: PlayerComponentInitOptions) {
      const { el, playerDataProvider } = options
      const [
        defaultMediaUri,
        poster,
        settings
      ] = await Promise.all([
        playerDataProvider.getDefaultMediaUri?.(),
        playerDataProvider.getPoster?.(),
        playerDataProvider.getSettings?.()
      ])

      return await new Promise<void>((resolve) => {
        const app = createApp({
          name: 'ExperiencePlyrComponent',
          render () {
            return h(PlyrComponent, {
              ref: 'plyrTemplate',
              class: toValue(options.rootClass),
              style: toValue(options.rootStyle),
              mediaUri: defaultMediaUri,
              'onPlyr-created': () => {
                resolve()
              },
              settings,
              poster
            })
          }
        })
        app.config.errorHandler = (err, instance, info) => {
          console.error('[ExperiencePlyrComponent] Vue error:', err, instance, info)
        }
        instance = app.mount(el) as any
      })
    },
    getPlayerElement: () => {
      return instance?.$refs.plyrTemplate.getPlyrElement()
    },
    getMediaControls: () => {
      return new PlyrMediaControls(() => {
        return instance?.$refs.plyrTemplate.getPlyr()
      })
    },
    setDebug (_debug: boolean) {
      // No-op
    }
  }
}
